var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleTab)?_c('button',{staticClass:"relative",attrs:{"title":_vm.title,"data-test":`tab-trigger--${_vm.tab}`},on:{"click":_vm.toggle}},[_c('span',{staticClass:"name block uppercase top-0",class:{'name--active': _vm.activeTab, 'name--dark-mode': _vm.darkMode}},[_vm._v(_vm._s(_vm.$t(_vm.tabName())))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }